/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
exports.shouldUpdateScroll = () => {
    if (window.performance) {
        // Current Performance API lv2 supported by Chrome, Safari, Edge, Firefox, IE10
        const lastNavigationType = window.performance.getEntriesByType('navigation')[0]?.type;
        return lastNavigationType === 'back_forward' || lastNavigationType === 'reload';
    }
    return false;
}
